import {
  faCalendarAlt,
  faTools,
  faMapMarkerAlt,
  faClipboardList,
  faBoxOpen,
  faLocationArrow,
  faToggleOn,
  faBox,
  faUser,
  faBuilding,
} from "@fortawesome/free-solid-svg-icons";
import createField from "../../utils/factory/createField";

export const baseShipmentFields = [
  {
    section: "Informações do Carregamento",
    fields: [
      createField({
        id: "movement.id",
        label: "Movimento",
        type: "select",
        placeholder: "Selecione o Movimento",
        icon: faTools,
      }),
      createField({
        id: "movement.organization_id",
        label: "Organização",
        type: "select",
        placeholder: "Selecione a organização",
        icon: faBuilding,
        disabled: true,
      }),
      createField({
        id: "movement.recipient_customer_id",
        label: "Cliente Destinatário",
        type: "select",
        placeholder: "Selecione o cliente destinatário",
        icon: faUser,
        disabled: true,
        fullWidth: true,
      }),
    ],
  },
];

export const baseMovementShipmentFields = [
  {
    section: "Informações do Carregamento",
    fields: [
      createField({
        id: "movement.id",
        label: "Movimento",
        type: "select",
        placeholder: "Selecione o Movimento",
        icon: faTools,
        isMulti: true,
        disabled: true,
      }),
      createField({
        id: "movement.organization_id",
        label: "Organização",
        type: "select",
        placeholder: "Selecione a organização",
        icon: faBuilding,
        disabled: true,
      }),
      createField({
        id: "movement.recipient_customer_id",
        label: "Cliente Destinatário",
        type: "select",
        placeholder: "Selecione o cliente destinatário",
        icon: faUser,
        disabled: true,
        fullWidth: true,
      }),
    ],
  },
];

export const validateItensShipmentFields = [
  {
    section: "Informações do Carregamento",
    fields: [
      createField({
        id: "movement.id",
        label: "Movimento",
        type: "multi-select",
        placeholder: "Selecione o Movimento",
        icon: faTools,
        isMulti: true,
        fullWidth: true,
      }),
    ],
  },
];

export const dynamicFields = {
  1: {
    section: "Itens do Movimento",
    view: "fields",
    count: 0,
    fields: [
      createField({
        id: "items.movement_item_id",
        label: "Item do Movimento",
        type: "select", // Alterado para 'select'
        placeholder: "Selecione o Item do Movimento",
        entity: "movementItem",
        column: "id",
        columnLabel: "id",
        isUnique: true,
        icon: faBoxOpen,
        disabled: true,
      }),
      createField({
        id: "items.serial_number",
        label: "Serial",
        type: "text",
        placeholder: "Selecione o serial",
        icon: faToggleOn,
        disabled: true,
      }),
      createField({
        id: "items.equipment_name",
        label: "Equipamento",
        type: "text",
        placeholder: "Selecione o equipamento",
        icon: faBox,
        disabled: true,
      }),
      createField({
        id: "items.address_id",
        label: "Endereço",
        type: "select",
        placeholder: "Selecione o endereço",
        icon: faMapMarkerAlt,
      }),
      createField({
        id: "items.location_id",
        label: "Localização",
        type: "select", // Alterado para 'select'
        placeholder: "Selecione a localização",
        notRequired: true,
        icon: faLocationArrow,
      }),
      createField({
        id: "items.details",
        label: "Detalhes",
        type: "textarea",
        placeholder: "Digite os detalhes",
        fullWidth: true,
        icon: faTools,
      }),
    ],
  },
};

export const editMovementsFields = [
  {
    section: "Informações do Carregamento",
    fields: [
      createField({
        id: "status",
        label: "Status",
        type: "text",
        fullWidth: true,
        icon: faClipboardList,
      }),
    ],
  },
];

export const detailsMovementFields = [
  {
    section: "Informações",
    fields: [
      createField({
        id: "id",
        label: "Nº Carregamento",
        type: "text",
        icon: faCalendarAlt,
        disabled: true,
      }),
      createField({
        id: "created_at",
        label: "Criado Em",
        type: "text",
        placeholder: "Digite a data de criação do carregamento",
        icon: faClipboardList,
        disabled: true,
      }),
      createField({
        id: "user.name",
        label: "Criado Por",
        type: "text",
        placeholder: "Digite o criador do carregamento",
        icon: faClipboardList,
        fullWidth: true,
        disabled: true,
      }),
    ],
  },
];

export const confirmShipmentFields = [
  {
    section: "Informações do Carregamento",
    fields: [
      createField({
        id: "shipment.recipient_customer_id",
        label: "Cliente Destinatário",
        type: "select",
        placeholder: "Selecione o cliente",
        icon: faBuilding,
      }),
      createField({
        id: "shipment.movement_type_id",
        label: "Tipo Movimento",
        type: "select",
        placeholder: "Selecione o tipo do movimento",
        icon: faUser,
      }),
    ],
  },
];
